<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FJWz0r/tc-custom/9781467463119.jpg?1734751852659" alt="This image is the cover for the book The Abuse of Conscience"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Abuse of Conscience
      </h1>
      <p class="bookDescription body article font2">
        <p><i>How important is conscience for the Christian moral life?</i> </p><p>In this book, Matthew Levering surveys twentieth-century Catholic moral theology to construct an argument against centering ethics on conscience. He instead argues that conscience must be formed by the revealed truths of Scripture as interpreted and applied in the church. Levering shows how conscience-centered ethics came to be—both prior to and following the Second Vatican Council—and how important voices from both the Catholic and Protestant communities criticized the primacy of conscience in favor of an approach that considers conscience within the broader framework of the Christian moral organism. </p><p>Rather than engaging with current hot-button issues, Levering presents and deconstructs the work of twenty-six noteworthy theologians from the recent past in order to work through core matters. He begins by examining the place of conscience in Scripture and in the Catholic “moral manuals” of the twentieth century. He then explores the rebuttals to conscience-centered ethics offered by pre- and post-conciliar Thomists and the emergence of a new, even more problematic conscience-centered ethics in German thought. Amid this wide-ranging introduction to various strands of Catholic moral theology, Levering crafts an incisive intervention of his own against the abuse of conscience that besets the church today as it did in the last century.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matthew Levering
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Matthew Levering</B>&#160;holds the James N. and Mary D. Perry Jr. Chair of Theology at Mundelein Seminary and is a longtime participant in Evangelicals and Catholics Together. Among his many other books are&#160;<I>Dying and the Virtues</I>&#160;and&#160;<I>Aquinas&#39;s Eschatological Ethics and the Virtue of Temperance.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?212ab472